/**
 * Social-Media-Kanäle von Equna (Footer-Verlinkung).
 *
 * ⚠️ HANDLES PRÜFEN VOR MERGE:
 * Die URLs unten sind Platzhalter mit dem Handle `equna`. Bitte vor dem
 * Mergen mit den echten Kanal-URLs ersetzen, falls das Handle abweicht.
 *
 * Nur Kanäle hier listen, die auch aktiv bespielt werden – ein toter Kanal
 * kostet mehr Vertrauen als er bringt. Eintrag entfernen blendet das Icon aus.
 */
export interface SocialLink {
  /** Plattform-Key (für i18n-aria-Labels: footer.social.aria.<key>) */
  key: 'tiktok' | 'instagram' | 'youtube'
  /** Voll-qualifizierte Kanal-URL */
  url: string
}

export const SOCIAL_LINKS: SocialLink[] = [
  { key: 'tiktok', url: 'https://www.tiktok.com/@equna.eu' },
  { key: 'instagram', url: 'https://www.instagram.com/equna.eu/' },
  { key: 'youtube', url: 'https://www.youtube.com/channel/UC7a7_DxM_urc8JGhWxZz-xA' },
]
